<template>
  <div>
    <wc-page-title title='SUBD Tiers'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Tier List'
            showAdd
            @add='newItem'
          >
            <template v-slot:appendTitle>
              <span class='ml-3 caption font-italic grey--text'>(Non-custom only)</span>
            </template>
            <v-data-table
              dense
              :items='subdTiers'
              :headers='headers'
              @click:row='openEdit'
              hide-default-footer
              :items-per-page='-1'
              sort-by='tier_number'
            >
              <template v-slot:item.su_price='{ item }'>
                {{ item.su_price | decMoney }}
              </template>
              <template v-slot:item.bd_price='{ item }'>
                {{ item.bd_price | decMoney }}
              </template>
              <template v-slot:item.su_time='{ item }'>
                {{ item.su_time + ' mins'}}
              </template>
              <template v-slot:item.bd_time='{ item }'>
                {{ item.bd_time + ' mins' }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

<!-- edit/new dialog box below  -->
<!-- should I move this into it's own component?  so it can be used in all instances of editing? (at least what's inside the form?) -->
    <wc-dialog
      :showDialog='showDialog'
      :title='itemCopy.id ? "Edit SUBD Tier" : "Create new SUBD Tier" '
      :icon='storePath.icon'
      :iconColor='storePath.iconColor'
      width='600'
      @cancel='cancelEdit'
      @save='save'
      :loading='isLoading'
      :disableButtons='!isFormValid'
    >
      <v-form ref='form' v-model='isFormValid'>
        <v-row>
          <v-col cols='12' sm='3'>
            <v-text-field
              ref='tier'
              label='Tier Number'
              :rules='[rules.required, localRules.notCustom]'
              v-model='itemCopy.tier_number'
              hint='eg. R1 or C1 (reference and sorting only)'
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='9'>
            <v-text-field
              label='Description'
              :rules='[rules.required, localRules.notCustom]'
              v-model='itemCopy.description'
              hint='this is the displayed value'
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row> 
          <v-col cols='12' sm='3'>
            <v-text-field
              prepend-inner-icon='mdi-currency-usd'
              label='SU Price'
              :rules='[rules.decimal]'
              v-model='itemCopy.su_price'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='3'>
            <v-text-field
              prepend-inner-icon='mdi-alarm'
              label='SU Time'
              :rules='[rules.int]'
              v-model='itemCopy.su_time'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='3'>
            <v-text-field
              prepend-inner-icon='mdi-currency-usd'
              label='BD Price'
              :rules='[rules.decimal]'
              v-model='itemCopy.bd_price'
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='3'>
            <v-text-field
              prepend-inner-icon='mdi-alarm'
              label='BD Time'
              :rules='[rules.int]'
              v-model='itemCopy.bd_time'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import irrigationAPI from '@/modules/irrigation/api/irrigations'
import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import _ from 'lodash'

export default {
  name: 'subd-tiers',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    showDialog: false,
    isFormValid: false,
    itemCopy: {},
    subdTiers: [],
    headers: [
      { text: 'Tier', value: 'tier_number', align: 'start', class:'overline' , width: '110' },
      { text: 'Description', value: 'description', class:'overline', align: 'start' },
      { text: 'SU Price', value: 'su_price', class:'overline', align: 'end', width: '140' },
      { text: 'BD Price', value: 'bd_price', class:'overline', align: 'end', width: '140' },
      { text: 'SU Time', value: 'su_time', class:'overline', align: 'end', width: '140' },
      { text: 'BD Time', value: 'bd_time', class:'overline', align: 'end', width: '140' },
    ]
  }),
  computed:{
    storePath () {
      return this.$store.state.icons.dataBox.basics
    },
    localRules() {
      return {
        notCustom: (value) => {
          return !_.includes(_.lowerCase(value), 'custom') || 'non-project specific tiers only'
        },
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      let tmp = await irrigationAPI.getSubdTiers()
      this.subdTiers = _.orderBy(tmp, 'tier_number')
      this.isLoading = false
    },
    async save() {
      this.isLoading = true
      if (this.itemCopy.id) {
        let tmp = await irrigationAPI.updateSubdTier(this.itemCopy)
        miscServices.replaceObject(this.subdTiers, tmp)
      } else {
        this.subdTiers.push(await irrigationAPI.newSubdTier(this.itemCopy))
      }
      this.isLoading = false
      this.showDialog = false
    },
    openEdit (item) {
      this.itemCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    newItem () {
      this.itemCopy = {}
      this.showDialog = true
      setTimeout(() => {
        this.$refs.form.resetValidation()
      }, 50)
      setTimeout(() => {
        this.$refs.tier.focus()
      }, 100)
    }
  },
  components: {
    
  }
}
</script>
